export const MiningToolUpgradePanel = ({ tools, smithing, toolUpgradeBusyKey, onUpgrade, sectionId }) => {
  const handleMaterial = (smithing?.materials || []).find((material) => material.id === "reinforced_handle");
  const ownedTools = (tools || []).filter((tool) => tool.owned);
  const handleBonus = handleMaterial?.tool_upgrade?.max_durability_bonus || 0;

  return (
    <section id={sectionId} data-testid="mining-tool-upgrade-panel" className="border border-amber-900/30 bg-zinc-950/80 p-4 rounded-sm space-y-4 scroll-mt-24">
      <div>
        <h2 className="font-cinzel text-base text-amber-300 uppercase tracking-wide">Pickaxe Upgrades</h2>
        <p className="text-xs text-zinc-500 mt-1">Use Reinforced Handles to permanently strengthen owned pickaxes.</p>
      </div>

      <div data-testid="mining-reinforced-handle-count" className="border border-zinc-800 bg-zinc-900/60 p-3 rounded-sm text-xs text-zinc-400">
        Reinforced Handles ready: <span className="text-zinc-100">{handleMaterial?.count ?? 0}</span>
      </div>

      <div className="grid xl:grid-cols-2 gap-4">
        {ownedTools.map((tool) => {
          const busy = toolUpgradeBusyKey === tool.id;
          const canUpgrade = (handleMaterial?.count ?? 0) > 0 && !tool.reinforced_handle_applied;
          return (
            <article key={tool.id} data-testid={`mining-tool-upgrade-${tool.id}`} className="border border-zinc-800 bg-zinc-900/60 p-4 rounded-sm space-y-3">
              <div className="flex items-start justify-between gap-3">
                <div>
                  <div className="font-cinzel text-zinc-100">{tool.name}</div>
                  <div className="text-xs uppercase tracking-[0.18em] text-zinc-500 mt-1">Durability {tool.durability}/{tool.max_durability}</div>
                </div>
                {tool.reinforced_handle_applied && <div className="text-xs uppercase tracking-[0.18em] text-amber-300">Upgraded</div>}
              </div>
              <div className="text-xs text-zinc-400">
                Reinforced Handle effect: <span className="text-zinc-100">+{handleBonus} max durability</span>
              </div>
              <button
                data-testid={`mining-tool-upgrade-button-${tool.id}`}
                onClick={() => onUpgrade(tool)}
                disabled={!canUpgrade || busy}
                className="px-4 py-2 border border-amber-600 text-amber-300 hover:bg-amber-950/20 rounded-sm text-xs font-cinzel uppercase tracking-[0.18em] disabled:opacity-50"
              >
                {busy ? "Applying" : tool.reinforced_handle_applied ? "Handle Applied" : "Apply Reinforced Handle"}
              </button>
            </article>
          );
        })}
      </div>
    </section>
  );
};